import { getRedirectTarget } from '@clientShared/hreflangRedirect';
import { setCookie } from '@clientShared/utils';
import { GetCountryPopupModal, ICountryPopupApiRequest } from '@clientWebServices/countrypopup.service';
import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { addCss } from '@shared/easyfy.utils';

@invoke
export default class CountryPopup {
  private countryPopup: HTMLElement | null = document.querySelector('[data-container="country-popup"]');
  private static COOKIE_NAME = 'countryPopupDismissed';

  onInit() {
    if (!this.isCountryPopupDismissed() && this.countryPopup) {
      this.getCountryPopup();
    }

    globalEvent({
      type: 'click',
      events: [
        {
          event: 'close-country-popup',
          callback: this.closeCountryPopup,
        },
      ],
    });
  }

  getCountryPopup = async () => {
    const countryPopup = this.countryPopup;
    if (!countryPopup) return;

    const countryCode = countryPopup.dataset.countryCode ?? '';
    const request: ICountryPopupApiRequest = {
      country: countryPopup.dataset.country ?? '',
      site: getRedirectTarget(countryPopup.dataset.site ?? '', countryCode),
    };

    await GetCountryPopupModal(request)
      .then((response) => {
        if (response.data.success && response.data.confirmationDialogHtml !== '') {
          if (this.countryPopup) {
            addCss(this.countryPopup, 'modal-window');
            this.countryPopup.innerHTML = response.data.confirmationDialogHtml;
          }
        }
      })
      .catch((error) => {
        console.error('Failed to get country popup modal.', {
          action: 'GetCountryPopupModal',
          error: error.message,
          data: {
            ...request,
            countryCode,
          },
        });
      });
  };

  closeCountryPopup = () => {
    this.countryPopup?.remove();
    this.setCookie();
  };

  static getCookieName(): string {
    return CountryPopup.COOKIE_NAME;
  }

  setCookie = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1); // Add 1 year

    setCookie('true', CountryPopup.getCookieName(), date);
  };

  isCountryPopupDismissed = (): boolean => {
    const cookie = document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith(CountryPopup.getCookieName() + '='))
      ?.split('=')[1];

    return cookie !== undefined;
  };
}
